import * as React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import SEO from "../components/seo"
import Banner from "../components/banner" 
import Title from "../components/Title" 
import HeroImage from "../components/heroImage"
import PageFooter from "../components/pageFooter"

class PorfolioPage extends React.Component {
  render() {

    const { data } = this.props

    const Images = data.portfolio.edges.map((el, index) => {
      if (index === 0) {
        return ( 
          <Banner key={index} caption={el.node.name} title={<Title Line1="Discover" Line2="The" Line3="Magic" />} image={el.node.image.gatsbyImageData}></Banner>
      )} else {
        return( 
          <HeroImage key={index} image={el.node.image.gatsbyImageData} title={el.node.name} slide={index+1} />
        )
      }
    })

    return (
      <Layout background="#7D5367" title="Folio" classes='sections-with--navigation'>
        <SEO title="Portfolio Stem Design" />

        {Images}       

        <div className="slide--marker" data-scroll data-title={data.portfolio.edges[0].node.name} data-scroll-call="change-slide" data-scroll-repeat="true" data-slide="1" data-scroll-position="bottom" ></div>

        <PageFooter image={data.filmsNComingSoon.edges[0].node.bannerImage.gatsbyImageData} title="Films" link="/films" />

      </Layout>
    )
  }
}

export default PorfolioPage

export const pageQuery = graphql`
  query {
    portfolio:allDatoCmsPortfolio {
      edges {
        node {
          id
          name
          image {
            gatsbyImageData(placeholder:DOMINANT_COLOR)
          }
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }
    filmsNComingSoon: allDatoCmsFilm(filter: {comingSoon: {eq: false}}) {
      edges {
        node {
          bannerImage {
            gatsbyImageData
          }
        }
      }
    }
  }
`
